import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthGate } from '../auth/AuthGate';
import { useI18n } from '../i18n/I18nProvider';
import { AppShell } from './AppShell';

const DashboardPage = lazy(() => import('../pages/DashboardPage'));
const ModulePage = lazy(() => import('../pages/ModulePage'));
const SettingsPage = lazy(() => import('../pages/SettingsPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const CommunityPage = lazy(() => import('../pages/CommunityPage'));
const CategoryPage = lazy(() => import('../pages/CategoryPage'));
const RoadmapPage = lazy(() => import('../pages/RoadmapPage'));
const AiPage = lazy(() => import('../pages/AiPage'));
const NetworkPage = lazy(() => import('../pages/NetworkPage'));
const MessagesPage = lazy(() => import('../pages/MessagesPage'));
const NotificationsPage = lazy(() => import('../pages/NotificationsPage'));
const OpportunitiesPage = lazy(() => import('../pages/OpportunitiesPage'));
const AdminPage = lazy(() => import('../pages/AdminPage'));
const ResetPasswordPage = lazy(() => import('../pages/ResetPasswordPage'));

function LoadingRoute() {
  const { m } = useI18n();
  return <div className="page-state"><div className="loading-mark" aria-hidden="true" /><p>{m.common.loading}</p></div>;
}

export function App() {
  return (
    <Suspense fallback={<LoadingRoute />}>
      <Routes>
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route element={<AuthGate><AppShell /></AuthGate>}>
            <Route index element={<DashboardPage />} />
            <Route path="roadmap" element={<RoadmapPage />} />
            <Route path="ai" element={<AiPage />} />
            <Route path="community" element={<CommunityPage />} />
            <Route path="categories/:slug" element={<CategoryPage />} />
            <Route path="network" element={<NetworkPage />} />
            <Route path="messages" element={<MessagesPage />} />
            <Route path="opportunities" element={<OpportunitiesPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="profile/:username" element={<ProfilePage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
